module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2nGy1"))).then(() => parcelRequire('1iHdE'));